import styled from 'styled-components';

export const ActivitiesPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const ActivitiesList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const ActivityCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.9rem;
`;

export const ActivityTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const ActivityMeta = styled.div`
  font-size: 0.8rem;
  color: #555555;
  margin-bottom: 6px;
`;
